var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-col',[_c('a-row',{attrs:{"span":12}},[_c('a-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.document.HISTORY,"pagination":{ pageSize: 15 },"bordered":""}})],1),_c('a-row',{staticStyle:{"margin-bottom":"15px"},attrs:{"span":12}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }